import React from "react";
import { ListGroup } from "react-bootstrap";
import { CheckCircleFill } from "react-bootstrap-icons";
import { SpeedPoint } from "../lib/cardPoints";

// One point with a tick on the plan card.
export const CardPoint = ({ children }: { children: React.ReactNode }) => (
  <ListGroup.Item className="border-0 p-0 position-relative align-middle">
    <CheckCircleFill
      style={{
        backgroundColor: "#03793E",
        borderRadius: "1em",
      }}
      className="
      position-absolute
      start-0
      top-0
      bottom-0
      m-auto"
      color="#F5E748"
    />
    {/* A block, thus a point that wraps keeps its indent on each line and
        does not go under the tick. */}
    <strong className="d-block ms-3">{children}</strong>
  </ListGroup.Item>
);

// The last point: the speed, with its footnote mark.
export const SpeedCardPoint = ({ point }: { point: SpeedPoint }) => (
  <CardPoint>
    {point.label}
    {point.superscript ? <sup>{point.mark}</sup> : point.mark}
    {` ${point.down}/${point.up}Mbps`}
  </CardPoint>
);
